module.exports = __webpack_public_path__ + "static/img/blog-entry-bg2.40e9a2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-entry-bg2.jpg
// module id = OWjd
// module chunks = 1